<template>
  <div>
    <navigation></navigation>
    <div class="about text-left mx-auto" style="max-width: 900px">
      <h3 class="text-center">Shop</h3>
      <p></p>
      <div class="card" style="width: 100%">
        <div class="card-body">
          <h5 class="card-title">Nothing to shop right now</h5>
          <p class="card-text">
            feel free to
            <router-link to="/contact"><u>contact</u></router-link> me
            <br />
          </p>
          <a
            href="https://www.paypal.me/oliverborner"
            target="new"
            class="card-link"
            ><i class="fa fa-coffee"></i> or instead buy me a coffe<br />
            <i class="fa fa-heart"></i> or just support the artist
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import navigation from "@/components/navigation.vue";
export default {
  components: {
    navigation,
  },
};
</script>

<style lang="scss">
@import "./../sass/_main.scss";
</style>
